export default "__VITE_ASSET__h$r7tLxW__"